import { Theme, css } from '@emotion/react';

export const container = ({ breakpoints, spacing }: Theme) => css`
  margin-bottom: 0;
  ${breakpoints.up('sm')} {
    margin-bottom: ${spacing(7)}px;
  }
`;

export const dividers = ({ breakpoints, colors, borderRadius, spacing }: Theme) => {
  /**
   * Children don't decide their padding or margin in that context, we set it
   * in Receipt.If a children has padding, remove it.
   */

  return css`
    --gap-size: 10px;
    --parent-padding: 0;

    &.MuiGrid-root {
      padding: var(--parent-padding);
    }

    > * {
      position: relative;
      margin-bottom: var(--gap-size);
      padding: ${spacing(2)}px;
    }

    > ::after {
      position: absolute;
      content: '';
      background: ${colors.bgLight};
      height: var(--gap-size);
      width: 100%;
      left: 0;
      bottom: calc(var(--gap-size) * -1);
    }

    ${breakpoints.up('sm')} {
      --gap-size: ${spacing(2)}px;
      --parent-padding: ${spacing(1)}px;

      > * {
        border: 1px solid ${colors.borderDefault};
        border-radius: ${borderRadius[100]};
      }

      > ::after {
        display: none;
      }
    }
  `;
};

export const receiptTitle = (theme: Theme) => css`
  border: none;
  padding-bottom: ${theme.spacing(1)}px;
`;
